// 获取版本号
const getVersion = async () => {
  if(!window.fetch) return { version: 1 }
  return fetch('./version.json?timestep=' + Date.now()).then((res) => {
    if(res.status == 200) return res.json()
    return { version: 1 }
  })
}
// 检查更新
const checkUpdate = async () => {
  let currentVersion = localStorage.getItem('version') // 当前版本
  const version = (await getVersion()).version
  if(!currentVersion || Number(version) > Number(currentVersion)) {
    location.reload() // 刷新当前页
    localStorage.setItem('version', version)
  }
}
export default checkUpdate


// WEBPACK FOOTER //
// ./src/common/uploadVersion.js